import React, { useState } from "react"

import ApiService from "@/services/Api"

import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
	Radio,
	RadioGroup
} from "@material-ui/core"

import { useSurveySubmit } from "@/contexts/SurveySubmitContext"
import useStyles from "@/components/SurveyFormContent/styles"

type SurveyOption = {
	value: string
	label: string
}

type SurveyFormContentProps = {
	options: SurveyOption[]
	responseMode: "single" | "multi"
	allowOther?: boolean
	endpoint: string
}

export const SurveyFormContent: React.FC<SurveyFormContentProps> = ({ options, responseMode, allowOther, endpoint }) => {
	const { submitFnRef, onClosePermanently } = useSurveySubmit()
	const classes = useStyles()

	const [selectedSingle, setSelectedSingle] = useState<string>("")
	const [selectedMulti, setSelectedMulti] = useState<Record<string, boolean>>({})
	const [otherText, setOtherText] = useState<string>("")
	const [isOtherChecked, setIsOtherChecked] = useState(false)

	const isOtherSelected = responseMode === "single" ? selectedSingle === "other" : isOtherChecked

	submitFnRef.current = async () => {
		const selected =
			responseMode === "single"
				? selectedSingle ? [selectedSingle] : []
				: Object.entries(selectedMulti).filter(([, isChecked]) => isChecked).map(([optionValue]) => optionValue)

		const payload: Record<string, unknown> = { selected }

		if (allowOther && isOtherSelected && otherText.trim()) {
			payload.otherText = otherText.trim()
		}

		try {
			await ApiService.post("/webhooks/external/call", { data: payload, url: endpoint })
		} finally {
			onClosePermanently()
		}
	}

	return (
		<FormControl component="fieldset" fullWidth>
			{responseMode === "single" ? (
				<RadioGroup
					value={selectedSingle}
					onChange={(event) => setSelectedSingle(event.target.value)}
				>
					{options.map((option) => (
						<FormControlLabel
							key={option.value}
							value={option.value}
							control={<Radio color="primary" size="small" />}
							label={option.label}
						/>
					))}
					{allowOther && (
						<FormControlLabel
							value="other"
							control={<Radio color="primary" size="small" />}
							label="Outro"
						/>
					)}
				</RadioGroup>
			) : (
				<FormGroup>
					{options.map((option) => (
						<FormControlLabel
							key={option.value}
							control={
								<Checkbox
									color="primary"
									size="small"
									checked={!!selectedMulti[option.value]}
									onChange={(event) =>
										setSelectedMulti((prev) => ({ ...prev, [option.value]: event.target.checked }))
									}
								/>
							}
							label={option.label}
						/>
					))}
					{allowOther && (
						<FormControlLabel
							control={
								<Checkbox
									color="primary"
									size="small"
									checked={isOtherChecked}
									onChange={(event) => setIsOtherChecked(event.target.checked)}
								/>
							}
							label="Outro"
						/>
					)}
				</FormGroup>
			)}

			{allowOther && isOtherSelected && (
				<textarea
					value={otherText}
					onChange={(event) => setOtherText(event.target.value)}
					placeholder="Descreva aqui..."
					className={classes.textArea}
				/>
			)}
		</FormControl>
	)
}
